import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgPeople = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M12 1a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6ZM12 12c5.523 0 10 4.477 10 10a1 1 0 0 1-2 0 8 8 0 0 0-16 0 1 1 0 0 1-2 0c0-5.523 4.477-10 10-10Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgPeople)
const Memo = memo(ForwardRef)
export default Memo
